<template>
    <div>
        <div class="row justify-content-center" v-if="programme">
            <div class="col-12">
                <RegisterForm v-bind="programme" :programme="programme" :programme-events="programme.events" entity="programme"  @on-pool="gotParticipants" :withSubmit="isOpen" :showSubmit="true"></RegisterForm>
            </div>
            <template v-if="programme && programme.type == 'individual'">
                <div class="col-md-12" v-for="(event, index) in programme.events" :key="index">
                    <PreviewCard v-bind="event" entity="event" v-on:card-click="onCardClick" card-type="long"></PreviewCard>
                </div>
            </template>
        </div>
        <div class="row justify-content-center mt-5" v-else>
            <div class="col-md-6">
                <h1 class="text-white" style="margin-bottom: 0;"><strong>Loading...</strong></h1>
                <h2 class="text-white">We are fetching the details for you. It'll be just a moment.</h2>
            </div>
        </div>
        
    </div>
</template>

<script>
import { PreviewCard, RegisterForm, PreviewForm } from 'src/components';
import { mapGetters } from 'vuex';

export default {
    name: 'RegisterProgramme',
    components:{
        RegisterForm,
        PreviewCard,
        PreviewForm
    },
    mounted(){
        this.$store.commit('setProgramme', null)
        this.$store.dispatch('getProgramme', this.$route.params.slug)
    },
    computed: {
        ...mapGetters({
            programme: 'getProgramme',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences'
        }),
        isOpen(){
            // temp. fix - value is supposed to come from server.
            if(this.programme){
                let check = new Date()
                let to = new Date(this.programme.close_date)
                let from = new Date(this.programme.open_date)
                return this.programme.isOpen ? this.programme.isOpen : (check.getTime() <= to.getTime() && check.getTime() >= from.getTime())
            }
            else
            return false
        }
    },
    methods: {
        gotParticipants(pool){
            // Note:- Work around for this.programme.participants_pool = pool
            // Vue is not reactive for such changes
            // https://vuejs.org/v2/guide/list.html#Object-Change-Detection-Caveats
            // Vue does not allow dynamically adding new root-level reactive properties to an already created instance.
            // However, it’s possible to add reactive properties to a nested object using the Vue.set(object, propertyName, value) 
            this.$set(this.programme, 'participants_pool', pool)
        },
        onCardClick(link){
            this.$router.push(`/event-${link}`)
        }
    }
}
</script>

<style>

</style>
